// Product Tabs

$(document).ready(function() {
  $(".set > a").on("click", function(e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
      .siblings(".content")
      .slideUp(200);
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    } else {
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
      .siblings(".content")
      .slideDown(200);
    }
  });
});

// page Owner
$('.warrantyLink').click(function(){
  $('.form_main').toggle();
  $('.custom_btn').toggleClass('icon_plus_minus');
});
// page Learn

$(document).ready(function(){
  $(".input_plus_button_article input").keyup(function(event) {
    if (event.keyCode === 13) {
      var height= $(".main-header-wrapper").height();
      var height1= height + 90;
      $('html, body').animate({
        scrollTop: $("#all_data_here").offset().top-height1
      }, 2000);

    }
  });
  $("#myBtn").click(function(){
    var height= $("#section-header").height();
    var height1= height + 90;
    $('html, body').animate({
      scrollTop: $("#all_data_here").offset().top-height1
    }, 2000);

  });

});


$(document).ready(function(){
  $('.blog_Article_slider_search input').keydown(function(){
    var val =$(".blog_Article_slider_search input").val().toLowerCase();
    $(".custom_class_h").each(function(){
      var value = $(this).find(".ArticleItem__Content").text().toLowerCase();
      var n = value.includes(val);
      console.log(n);
      if(n){
        $(this).show();
        $(".sorry_message").hide();
      }
      else{
        $(this).hide();
        $(".sorry_message").show();
      }

    });
  });

  $('.blog_Article_slider_search input').keyup(function(){
    var val =$(".blog_Article_slider_search input").val().toLowerCase();
    $(".custom_class_h").each(function(){
      var value = $(this).find(".ArticleItem__Content").text().toLowerCase();
      var n = value.includes(val);
      if(n){
        $(this).show();
        $(".sorry_message").hide();
      }
      else{
        $(this).hide();
        $(".sorry_message").show();
      }

    });
  });

});

$('.blog_Article_slider_search input').keyup(function(){
  var val =$(".blog_Article_slider_search input").val().toLowerCase();
  $(".custom_class_h").each(function(){
    var value = $(this).find(".ArticleItem__Content").text().toLowerCase();
    var n = value.includes(val);
    if(n){
      $(this).show();
      $(".sorry_message").hide();
    }
    else{
      $(this).hide();
      $(".sorry_message").show();
    }

  });
});


$(document).ready(function(){
  $('.similar_select').change(function() {
    var val1 =$("#Resource_Topic").val();
    var val3 =$("#owner").val();
    $(".custom_class_h").each(function(){
      var value = $(this).find(".values_hai").text();
      var n = value.includes(val1);
      var n2 = value.includes(val3);

      if(n && n2 ){
        $(this).show();
        $(".sorry_message").hide();
      }
      else{
        $(this).hide();
      }
      if($(".custom_class_h:visible").length < 1){
        console.log($(".custom_class_h:visible").length);
        $(".sorry_message").show();
      }

    });
  });
  $('.upsell_section.categories_section').slick({
    slidesToShow: 4,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    dots: false,
    infinite: false,
    responsive: [{
      breakpoint: 775,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,


      }

    }, {
      breakpoint: 585,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,


      }
    },{
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,


      }
    }]
  });

  $('.ss.upsell_section.shop_section').slick({
    slidesToShow: 4,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    dots: false,
    infinite: false,
    responsive: [{
      breakpoint: 775,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,


      }

    }, {
      breakpoint: 585,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,


      }
    },{
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,


      }
    }]
  });

  $('.product-gallery--navigation').slick({
    slidesToShow: 5,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    dots: false,
    infinite: true,
    centerMode: false,
    responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,


      }

    }, {
      breakpoint: 720,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,


      }
    },
                 {
                   breakpoint: 550,
                   settings: {
                     slidesToShow: 4,
                     slidesToScroll: 1,


                   }
                 },
                 {
                   breakpoint: 401,
                   settings: {
                     slidesToShow: 3,
                     slidesToScroll: 1,


                   }
                 }]
  });
});

//  $('.tabsproduct').each(function(){
//       var active, content, links = $(this).find('a');
//       active = links.first().addClass('active');
//       content = $(active.attr('href'));
//       links.not(':first').each(function () {
//         $($(this).attr('href')).hide();
//       });
//       $(this).find('a').click(function(e){
//         active.removeClass('active');
//         content.hide();
//         active = $(this);
//         content = $($(this).attr('href'));
//         active.addClass('active');
//         content.show();
//         return false;
//       });
//     });
$(document).ready(function () {
  if (window.location.href.indexOf("#") > -1) {
    var header_height = $(".main-header").height();
    $('html, body').animate({
      scrollTop: $("#replacement-parts-product").offset().top - header_height
    }, 2000);
  }
});

console.log('test log');


